'use strict';

function HelpdeskListDropdown() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AnalyticsData];
  this.url;
  this.onlyPublished;
  this.sendDlevent;
  this._analytics = new Analytics();
  this.brandId = null;

  this.init = function () {
    this._$node = $(this.node);

    $.ajax(this.url, {
      cache: false,
      success: this._onRequestSuccess.bind(this),
      dataType: 'json'
    });
  };

  this.initAllReady = function () {
    this._$node.show();
  };

  this._onRequestSuccess = function (data) {
    this._mapResponseData(data._embedded);
    $.each(this._faqs, this._constuctListItem.bind(this));
    // IE fix, remove() is not supported in WIN10
    this._$node[0].removeChild(this._$node[0].firstElementChild);
    if (this.sendDlevent) {
      this._sendDlevent(data._embedded.entries);
    }
    $('.js--loader').remove();
  };

  this._mapResponseData = function (data) {
    var _this = this;

    this._faqs = $.map(data.entries, function (entry) {
      if (_this.onlyPublished) {
        if (entry.in_support_center) {
          entry = {
            subject: entry.subject,
            body: entry.body,
            public_url: entry.public_url
          };
        }
      } else {
        entry = {
          subject: entry.subject,
          body: entry.body,
          public_url: entry.public_url
        };
      }
      return entry;
    });
    this._faqs = this._faqs.slice(0, 5);
  };

  this._constuctListItem = function (index, faq) {
    var template = $(this.node)[0].firstElementChild;
    var $node = $(template.cloneNode(true));

    if (this.onlyPublished) {
      var $content = $($.parseHTML(faq.body)[0]);
      $content = $content.prop('outerHTML') ? $content.prop('innerHTML') : $content[0].wholeText;
      var readMode = $node.find('.js--link');
      var link = faq.public_url;
      if (this.brandId) {
        link = link + '?b_id=' + this.brandId;
      }
      readMode.attr('href', link);
    } else {
      var $content = faq.body;
    }

    var subject = this._cleanCategory(faq.subject);

    var checkbox = $node.find('.js--trigger');
    var label = $node.find('.js--label');
    var heading = $node.find('.js--heading');
    var content = $node.find('.js--content');
    var analyticsString = this.product + '-Help-Section ' + (index + 1) + '-null-Click';
    checkbox.attr('id', subject);
    label.attr('for', subject);
    label.attr('data-analytics-id', analyticsString);
    heading.append(faq.subject);
    content.append($content);

    this._$node.append($node);
    $node.removeClass('hide');
  };

  this._cleanCategory = function (category) {
    return category.replace(/\s+/g, '').toLowerCase();
  };

  this._sendDlevent = function (entryArray) {
    var ids = [];
    $.each(entryArray, function (index, entry) {
      ids.push(entry.id);
    });
    this._analytics.pushEvent('help-desk', { helpDeskIDs: [ids.join(' ')] });
  };
}